// extracted by mini-css-extract-plugin
export var linkText = "_pu-0";